import React, { useEffect } from 'react';
import Router from './shared/Router';
import env from './config/env';

import './vendor/styles/bootstrap.scss';
import './vendor/styles/appwork.scss';
import './vendor/styles/theme-corporate.scss';
import './vendor/styles/colors.scss';
import './vendor/styles/uikit.scss';
import './vendor/libs/react-ladda/react-ladda.scss';
import './vendor/libs/react-toastify/react-toastify.scss';
import './vendor/libs/react-bootstrap-table2/react-bootstrap-table2.scss';
import './vendor/libs/sweetalert2/sweetalert2.scss';
import './shared/layouts/print.scss';
import './shared/layouts/global.scss';
import './shared/layouts/aspect-ratio.scss';

const App = () => {
  useEffect(() => {
    document.body.dataset.userAppType = env.USER_APP_TYPE || '';
  }, []);

  return <Router />;
};

export default App;
